import React from "react";

function NotFound() {

    return (
        <h1>NOT FOUND</h1>
    )
}

export default NotFound;